import ApiService from '../../components/api_services/apiService.jsx';

import { ReactComponent as Edit } from '../../components/icons/edit.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import CustomButton from '../../components/components/custom_button/customButton.jsx';


import {setViewedUser, toggleCheckedItem, toggleEditModal} from '../../store/userTabSlice';
import apiService from "../../components/api_services/apiService.jsx";

export const fetchUsers = async (sortBy, sortDirection, currentPage, role, dispatch, setMaxPages, setRows, checkedItems, keyword) => {
  try {
    const checkedSortBy = sortBy === null || sortDirection === null ? null : sortBy;
    const checkedSortDirection = sortBy === null || sortDirection === null ? null : sortDirection;
    const response = await ApiService.getUsers(checkedSortBy, checkedSortDirection, currentPage, role, keyword);
    console.log('Odpowiedź z API:', response);

    dispatch(setMaxPages(response.maxPage)); // Ustawienie maksymalnej liczby stron na podstawie danych z API

    // Mapowanie danych z API do formatu zgodnego z tabelą
    const mappedRows = response.data.map((user) => [
      <input
        type="checkbox"
        checked={checkedItems && checkedItems.includes(user[0])} // Sprawdzenie, czy id znajduje się w checkedItems
        onChange={() => dispatch(toggleCheckedItem(user[0]))} // Dodanie/Usunięcie id z listy
      />,
      <div className={user[8] ? 'red-row' : ''}>{user[0]}</div>, // ID użytkownika
      <div className={user[8] && user[9] ? 'red-row' : ''}>
        {user[1]}
        <CustomButton
          name=">"
          baseClass="custom-button-in-the-cell"
          bordersClassPrefix="border-gray-"
          hoverClass="hover-effect"
          activeClass=""
          borders="LRBT"
          onClick={() => {
              dispatch(setViewedUser(user[0]));
              dispatch(toggleEditModal());
          }}
          toggleActive="false"
        />
      </div>,
      <div>{user[2]}</div>, // Adres e-mail
      <div>{user[3]}</div>, // Numer telefonu
      <div>{user[4]}</div>, // Dyscypliny
      <div>{user[5]}</div>, // Treningi
      <div>{new Date(user[6]).toISOString().split('T')[0]}</div>, // Formatowanie daty na YYYY-MM-DD
      user[7] === 'BASIC' ? <div className='planA'>{user[7]}</div>:
      user[7] === 'PREMIUM' ? <div className='planB'>{user[7]}</div> : <div className='planC'>{user[7]}</div>, // Pakiet
      <div>
        <Edit className="menu-icon" onClick={() => {
            dispatch(setViewedUser(user[0]));
            dispatch(toggleEditModal());
        }} />
        <Trash className="menu-icon" onClick={() => {
            apiService.deleteUsersByIdList([user[0]]);
            alert('User mark for deleting. Will be anonymized at midnight!');
        }} />
      </div>,
    ]);

    setRows(mappedRows); // Ustawienie wierszy w stanie
  } catch (error) {
    console.error('Błąd podczas pobierania danych:', error);
  }
};